import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../utils';

export const CashDisbursementApi = createAsyncThunk(
  'CashDisbursementApi',
  async (cashDisbursementPayload, { dispatch }) => {
    dispatch({ type: 'CashDisbursementApi/pending', payload: {} });

    const {
      customerId,
      Authorization,
      customerRefNum,
      successFn = () => {},
    } = cashDisbursementPayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'loanbooking3/cashdisbursementjourney',
      payload: {
        customerRefNum,
        appId: APP_ID,
        appVersion: APP_VERSION,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const disbursementRes = res;
        dispatch({
          type: 'CashDisbursementApi/fulfilled',
          payload: disbursementRes,
        });
        if (successFn) successFn();
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'CashDisbursementApi/rejected', payload: err });
      },
    });
  }
);

export const CashDisbursementApi_extrareducer = {
  [CashDisbursementApi.pending]: (state, action) => {
    state.cashDisbursementApiState.isLoading = true;
  },
  [CashDisbursementApi.fulfilled]: (state, action) => {
    state.cashDisbursementApiState.isLoading = false;
    state.cashDisbursementApiState.isSuccess = true;
    state.cashDisbursementApiState.isError = false;
    state.cashDisbursementApiState.response = action.payload;
  },
  [CashDisbursementApi.rejected]: (state, action) => {
    state.cashDisbursementApiState.isLoading = false;
    state.cashDisbursementApiState.isSuccess = false;
    state.cashDisbursementApiState.isError = true;
    state.cashDisbursementApiState.response = action.payload;
  },
  [CashDisbursementApi.reset]: (state, action) => {
    state.cashDisbursementApiState.isLoading = false;
    state.cashDisbursementApiState.isSuccess = false;
    state.cashDisbursementApiState.isError = false;
    state.cashDisbursementApiState.response = {};
  },
};
